import gql from 'graphql-tag';

export const GET_DOCUMENTS_AND_APPLICATIONS = gql`
  query ($accountId: ID!) {
    documents: getDocs(accountId: $accountId) {
      regular {
        path
        lastModified
      }
      internal {
        path
        lastModified
        displayName
        policyId
      }
    }
    unsignedApplications: getUnsignedApplications(accountId: $accountId) {
      policyId
      applicationUrl
    }
  }
`;
export const GET_UPLOAD_URL = gql`
  query ($accountId: ID!, $fileName: String!, $mimeType: String!) {
    uploadUrl: getUploadUrl(accountId: $accountId, fileName: $fileName, mimeType: $mimeType) {
      url
    }
  }
`;

export const DELETE_INTERNAL_DOCUMENT = gql`
  mutation ($accountId: ID!, $key: String!) {
    deleteInternalDocument(accountId: $accountId, key: $key) {
      success
      key
    }
  }
`;

export const SET_DOCUMENT_LABEL = gql`
  mutation ($accountId: ID, $key: String!, $label: String) {
    setDocumentLabel(accountId: $accountId, key: $key, label: $label) {
      success
      key
      displayName
    }
  }
`;

export const SET_DOCUMENT_POLICY = gql`
  mutation ($accountId: ID, $key: String!, $policyId: String) {
    setDocumentPolicy(accountId: $accountId, key: $key, policyId: $policyId) {
      success
      key
      policyId
    }
  }
`;

export const REGENERATE_POLICY_DOCUMENTS = gql`
  mutation regeneratePolicyDocuments($policyId: ID!) {
    documents: regeneratePolicyDocuments(policyId: $policyId) {
      success
      reason
    }
  }
`;
